import {defineStore as _defineStore} from 'pinia'
import {ref} from "vue";
import {clear} from "@/plugins/obscore";
import {getRequest, postRequest, putRequest} from "@/plugins/axioscalls";

export function defineStore(name, config) {
    return _defineStore(name, {
        state: () => ({
            _results: {},
            expireAfter: 1, //minutes (0: always refresh, -1: never expire)
            expireTS: null,
            forceReload: false,
            loaded: false,
            loadedTS: null,
            abortLoading: false,
            pagesLoaded: [],
            totalRecords: 64,
            perPage: 32,
            currentPage: 1,
            subject: ref({}),
            loading: false,

            ...config.state
        }),
        getters: {
            results() {
                if (this.shouldLoad()) {
                    this.fetchResults().then(() => {
                        return this._results
                    })
                }
                return this._results
            },
        },
        actions: {
            forceRefresh() {
                this.isRefreshing = true;
                this.fetchResults().then(() => {
                    this.isRefreshing = false;
                })
            },
            async fetchResults() {
                this.loading = true;
                let store = this;
                if(store.expireAfter<2){
                    return await getRequest(this.apis.list, {})
                        .then((data) => {
                            store._results = data.data.reduce((obj, item) => {
                                return {
                                    ...obj,
                                    [item['id']]: item,
                                };
                            }, store._results)
                            store.loadedTS = new Date();
                            store.expireTS = Object.freeze(new Date(store.loadedTS.getTime() + 60000 * store.expireAfter))
                        })
                        .finally(() => {
                            store.loading = false;
                            store.loaded = true
                            store.expireAfter++;
                        })
                }

            },
            // loadResults() {
            //     for (let i = 0; i < 32; i++) {
            //         this._results[i] = {}
            //         for (let prop in this.fields) {
            //             this._results[i][prop] = `${name} - ${prop} - ${i}`
            //         }
            //     }
            //     this.loaded = true
            // },
            updateValidity() {
                this.loaded = true
                this.loadedTS = Date()
                this.expireTS = Date()
            },
            resetValidity() {
                this.loaded = false
                this.loadedTS = null
                this.expireTS = null
            },
            load(url, force = false) {
                this.abortLoading = false

                if (force == true) {
                    this.resetValidity()
                    this.forceReload = true
                }

                if (this.expired) {
                    this.pagesLoaded = 0
                    this.currentPage = 1
                    this.getData(this.buildPaginationUrl(url))
                } else {
                    // this.delegate?.hasFinishedLoadingData(status: .didLoadRemoteData, message: "")
                }

            },
            loadNext(url) {
                if (this.pagesLoaded >= this.pages) {
                    this.hasFinishedLoadingPages()
                    return
                }
                while (this.currentPage < this.pages) {
                    this.currentPage += 1
                    this.getData(this.buildPaginationUrl(url))
                }
            },
            buildPaginationUrl(url) {
                console.log(url)
                // let pagination = "filter[_per_page]=\(this.perPage)&filter[_page]=\(this.currentPage)"

                // if (url.contains("?")) {
                //     return "\(url)&\(pagination)"
                // } else {
                //     return "\(url)?\(pagination)"
                // }
            },
            hasFinishedLoadingPages() {
                this.updateValidity()
            },
            async loadObject(id) {
                this.loading = true;
                let store = this;
                let url = this.apis.get.replace("{id}", id)
                return await getRequest(url, {})
                    .then((data) => {
                        Object.assign(store.subject, data.data);
                        this._results[store.subject.id] = {...store.subject}
                    })
                    .finally(() => {
                        store.loading = false;
                    })
            },
            getNewInstance() {
                let subject = {}
                clear(this.subject)
                for (const fieldName in this.fields) {
                    let field = this.fields[fieldName]
                    switch (field.type) {
                        case "array":
                        case "image":
                        case "file":
                            subject[fieldName] = []
                            break;
                        default:
                            subject[fieldName] = ""
                    }
                }
                Object.assign(this.subject, subject);
            },
            async createObject(object) {
                const store = this;
                let url = this.apis.create
                store.loading = true;
                await postRequest(url, object, {})
                    .then((data) => {
                        store._results[data.data.id] = data.data
                    })
                    .finally(() => {
                        store.loading = false;
                    }).catch(err => {
                        throw err
                    })
            },
            async updateObject(object) {
                const store = this;
                let url = this.apis.edit.replace("{id}", object.id)
                // object.price.currencySet = "USD"
                // object.price.currencySet = null
                store.loading = true;
                await putRequest(url, object, {})
                    .then((data) => {
                        store._results[data.data.id] = data.data
                    })
                    .finally(() => {
                        store.loading = false;
                    }).catch(err => {
                        console.log(err)
                        throw err
                    })
            },
            shouldLoad() {
                return (!this.loaded || this.forceReload || this.expireTS <= new Date()) && !this.loading;
            }
        }
    })
}